import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as runReducer from "containers/Run/reducer";
import * as predictReducer from "containers/Predict/reducer";
import * as projectReducer from "containers/Project/reducer";

import Mini from "components/Results/Mini";

class MiniContainer extends React.PureComponent {
  render() {
    const { model, getModelFeature } = this.props;

    const featureBars =
      model && model.featureInfo && model.featureInfo.length > 0
        ? model.featureInfo.map((f) => ({
            left: f.score,
            label: f.label,
            leftModel: model.id,
            values: getModelFeature(model.id, f.label).values
          }))
        : [];

    return <Mini {...this.props} featureBars={featureBars} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  initJob: () => {},

  getModelFeature: (modelId, feature) =>
    dispatch(runReducer.getModelFeatureInfoWithDispatch(ownProps.id, modelId, feature)),

  updateChooseModel: (model) => dispatch(runReducer.updateFeatureSelection(ownProps.id, model, true)),

  updateIgnoredModel: (model, value) => dispatch(setupReducer.updateIgnoredModel(ownProps.id, model, value)),
  setIsAllowedInFrontier: (modelName, isAllowed) =>
    dispatch(projectReducer.setIsAllowedInFrontier(ownProps.id, modelName, isAllowed))
});

const mapStateToProps = (state, ownProps) => {
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const model = runReducer.getSelModel(state, ownProps.id, models) || {};

  return {
    models: models,
    model: model,

    modelFeedback: runReducer.getSortedModelFeedback(state, ownProps.id, model.id),

    netImpactLabel: setupReducer.getNetImpactLabel(state, ownProps.id),
    isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    isForceOptimized: setupReducer.getIsForceOptimized(state, ownProps.id),
    trueAction: setupReducer.getTrueAction(state, ownProps.id, true),

    unitRevenue: projectReducer.getUnitRevenue(state, ownProps.id),

    ignoredModels: setupReducer.getIgnoredModels(state, ownProps.id),

    scenarios: predictReducer.getScenarios(state, ownProps.id),
    scenarioIndex: predictReducer.getScenarioIndex(state, ownProps.id),
    colSelections: predictReducer.getColumnSelections(state, ownProps.id),
    modelIsAllowedInFrontier: projectReducer.getIsAllowedInFrontier(state, ownProps.id, model.id),
    currentStateImpact: runReducer.getCurrentStateImpact(state, ownProps.id),

    setup: setupReducer.getSetup(state, ownProps.id),
    setupLabels: setupReducer.getSetupLabels(state, ownProps.id),
    holdoutDataPath: runReducer.getModelHoldoutDataPath(state, ownProps.id, model.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(MiniContainer);
